import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";
import { RECOIL_PERSIST_KEY } from "../sharedStrings";

const { persistAtom } = recoilPersist({
  key: RECOIL_PERSIST_KEY,
});

export interface AgreeState {
  agreementTime1?: Date | null;
  agreementTime2?: Date | null;
}

export interface TypeState {
  selectedType?: Number;
}

export const typeState = atom<TypeState>({
  key: `type`,
  default: {
    selectedType: 0,
  },
});

export const agreeState = atom<AgreeState | null>({
  key: `agree`,
  default: null,
  effects_UNSTABLE: [persistAtom],
});

export const photoAgreeState = atom<Date | null>({
  key: `photoAgree`,
  default: null,
});
